<div class="main-wrapper-section">
    <div class="common-header">
        <h3>General</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <p class="heading-text" style="color:#2a3644; font-weight:600;">Engage Site Configuration</p>
            <div class="flex-form" style="align-items:flex-end">
                <div class="form-group flex-none min-width300">
                    <label>Site (Class 1)</label>
                    <h5>{{curSite?.class1Display}}</h5>
                </div>
                <div class="form-group flex-none min-width300">
                    <label>Club</label>
                    <h5>{{curTeam?.display}}</h5>
                </div>
            </div>
            <hr />
            <p class="heading-text">The following fields are used to customize each club.</p>
            <div class="flex-form">
                <div class="form-group flex-none min-width300">
                    <label>Site</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteName')">PH_CMSiteName</div>
                    <input class="form-control" [(ngModel)]="phLocation" maxlength="50" />
                </div>
                <div class="form-group flex-none min-width300">
                    <label>Tax Rate %</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteTaxRate')">PH_CMSiteTaxRate</div>
                    <input class="form-control" type="text" [(ngModel)]="taxRate" maxlength="50" style="text-align: right;" appPercentageDirective />
                </div>
            </div>
            <div class="flex-form">
                <div class="form-group flex-none min-width300">
                    <label>Address</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteAddress')">PH_CMSiteAddress</div>
                    <input class="form-control" [(ngModel)]="phAddress" maxlength="50" />
                </div>
                <div class="form-group flex-none min-width300">
                    <label>City</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteCity')">PH_CMSiteCity</div>
                    <input class="form-control" [(ngModel)]="phCity" maxlength="50" />
                </div>
                <div class="form-group">
                    <label>State</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteState')">PH_CMSiteState</div>
                    <kendo-combobox [data]="stateList"
                                    class="form-control min-width300"
                                    [valuePrimitive]="true"
                                    [kendoDropDownFilter]="filterSettings"
                                    [filterable]="true"
                                    [(ngModel)]="stateCode"
                                    textField="text"
                                    valueField="value">
                    </kendo-combobox>
                </div>
            </div>
            <div class="flex-form">
                <div class="form-group">
                    <label class="fldtitle">Zip</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteZip')">PH_CMSiteZip</div>
                    <input type="text" name="txtZip" [(ngModel)]="phZip" maxlength="6" autocomplete="off" value="247001" id="ContentPlaceHolder1_txtZip" class="form-control">
                </div>
                <div class="form-group">
                    <label>Country</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteCountry')">PH_CMSiteCountry</div>
                    <kendo-combobox [data]="countryDD"
                                    class="form-control min-width300"
                                    [valuePrimitive]="true"
                                    [kendoDropDownFilter]="filterSettings"
                                    [filterable]="true"
                                    textField="text"
                                    [(ngModel)]="countryCode"
                                    valueField="value"
                                    (valueChange)="onChangeCountry($event)">
                    </kendo-combobox>
                </div>
            </div>
            <div class="flex-form">
                <div class="form-group flex-none min-width300">
                    <label>Custom 1</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteCustom1')">PH_CMSiteCustom1</div>
                    <input class="form-control" [(ngModel)]="custom1" maxlength="50" />
                </div>
                <div class="form-group flex-none min-width300">
                    <label>Custom 2</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteCustom2')">PH_CMSiteCustom2</div>
                    <input class="form-control" [(ngModel)]="custom2" maxlength="50" />
                </div>
                <div class="form-group flex-none min-width300">
                    <label>Custom 3</label>
                    <div class="clickable m-placeholder" (click)="copyToClip('PH_CMSiteCustom3')">PH_CMSiteCustom3</div>
                    <input class="form-control" [(ngModel)]="custom3" maxlength="50" />
                </div>
            </div>
            <div class="button-group">
                <div class="form-group">
                    <button class="primary-btn" (click)="updateSite()" [disabled]="!getValid()">Save</button>
                </div>
            </div>
        </div>
    </div>
</div>
